export const TEXTS = {
  DEVICE_TYPE: 'Тип устройства',
  NO_DEVICE: 'устройство не привязано',
  NO_VIDEO: 'нет поддержки видео',

  WEB: 'Веб-плеер',
  ALICE: 'Алиса',
  ANDROID: 'Android-приложение',
  DESKTOP: 'Приложение для ПК',
  IOS: 'Ios-приложение',
  ANDROID_BOX: 'Плеер «Звук Бизнес»',
  BOOM_SPEAKER: 'Умная колонка SberBoom',
  DESKTOP_BOX: 'RPI',
  DEFAULT: 'Приложение',
};
